// A contact's name as the CRM screens show it. A name the server withheld
// (envelope-encrypted and not unlockable for this caller) reads "Name locked"
// with a lock and the reason on hover, like the locked invention declaration
// card — never "Unnamed contact" or a blank cell. Story #6761 (F4).
import { Lock } from 'lucide-react'
import { contactDisplayName, contactNameLocked, CONTACT_NAME_LOCKED_HINT } from '../../utils/crmPipeline'
import type { CrmContact } from '../../types'

export default function ContactName({ contact }: { contact: CrmContact }) {
  const name = contactDisplayName(contact)
  if (!contactNameLocked(contact)) return <>{name}</>
  return (
    <span className="inline-flex items-center gap-1 italic text-gray-500" title={CONTACT_NAME_LOCKED_HINT} data-testid="contact-name-locked">
      <Lock size={12} aria-hidden /> {name}
    </span>
  )
}
